import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import CatatanPraSedasiSvc from "@/services/CatatanPraSedasi";

@Module({ store, dynamic: true, namespaced: true, name: "catatan-pra-sedasi" })
class CatatanPraSedasiModule extends VuexModule {
  dataList: any[] = [];
  loading = false;
  registerId: string = null;

  @Mutation SET_DATALIST(val: any[]) {
    this.dataList = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_REGISTER_ID(val: string | number) {
    this.registerId = val == null ? null : String(val);
  }

  @Mutation CLEAR_STORE() {
    this.dataList = [];
    this.registerId = null;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    if (this.registerId !== String(reg)) {
      this.SET_DATALIST([]);
    }

    this.SET_REGISTER_ID(reg);

    try {
      const dt = await CatatanPraSedasiSvc.getByRegister(reg);

      if (this.registerId !== String(reg)) return;

      const { data } = dt.data;
      this.SET_DATALIST(data || []);
    } catch {
      if (this.registerId === String(reg)) {
        this.SET_DATALIST([]);
      }
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action reset() {
    this.CLEAR_STORE();
  }
}

export const storeCatatanPraSedasi = getModule(CatatanPraSedasiModule);
